import { render, staticRenderFns } from "./TextBegin.vue?vue&type=template&id=776ea88e"
import script from "./TextBegin.vue?vue&type=script&lang=ts"
export * from "./TextBegin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports